import { render, staticRenderFns } from "./ForBusinesses.vue?vue&type=template&id=292cd18d&scoped=true&"
import script from "./ForBusinesses.vue?vue&type=script&lang=js&"
export * from "./ForBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./ForBusinesses.vue?vue&type=style&index=0&id=292cd18d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292cd18d",
  null
  
)

export default component.exports